import { useCallback, useRef } from 'react';

import { generateURL, uploadS3 } from 'src/thunks/fileUpload';
import { UPLOAD_MODULE } from 'src/constants/app';
import { useAppDispatch } from 'src/store';

export type LikeFile = { name?: string; type: string };

export type FileUpload = {
  origin: File | LikeFile;
  status?: 'loading' | 'error' | 'success';
  url?: string;
};

const useUpload = () => {
  const fileUploadRef = useRef<FileUpload>();
  const dispatch = useAppDispatch();

  const handleUpload = async (
    file: File,
    module?: string,
  ): Promise<FileUpload> => {
    fileUploadRef.current = {
      origin: file,
      status: 'loading',
    };

    const result = await dispatch(
      generateURL({
        file_name: file.name,
        module: module || UPLOAD_MODULE.OTHERS,
      }),
    );

    if (generateURL.fulfilled.match(result)) {
      const { presign_url, access_url } = result.payload.data;

      await dispatch(
        uploadS3({
          file,
          url: presign_url,
          ext: file.type,
          onSuccess: () => {
            fileUploadRef.current = {
              origin: file,
              status: 'success',
              url: access_url,
            };
          },
          onError: () => {
            fileUploadRef.current = {
              origin: file,
              status: 'error',
            };
          },
        }),
      );
    }

    return fileUploadRef.current;
  };

  return { handleUpload: useCallback(handleUpload, []) };
};

export default useUpload;
